<template>
    <div class="page_hx_core flex-col">
        <div class="group_10 flex-row">
            <div class="section_9 flex-col">
                <span class="text_27">协助应对企业面临的普遍问题</span>
                <span class="text_28">SOLVE&nbsp;THE&nbsp;CORE&nbsp;PAIN&nbsp;POINTS</span>
                <div class="list_10">
                    <div class="list-items_1 flex-col" v-for="(item, index) in loopData1" :key="item.id"
                         @click="toggleItem(item.id)">
                        <img
                                v-if="item.slot1 === 1 && !activeItems[item.id]"
                                class="image_10"
                                referrerpolicy="no-referrer"
                                :src="item.specialSlot1.lanhuimage0"
                        />
                        <img
                                v-if="item.slot2 === 2 && !activeItems[item.id]"
                                class="label_5"
                                referrerpolicy="no-referrer"
                                src="../../../assets/advisory/advisory_solve_icon_01.png"
                        />
                        <span class="text_29" v-html="item.lanhutext0" v-show="!activeItems[item.id]"></span>

                        <div class="hover-mask" v-show="activeItems[item.id]">
                            <div class="hover-content">
                                <div class="problem-section">
                                    <div class="box_16 flex-col">
                                        <div class="icon-wrapper flex-row justify-between">
                                            <img
                                                    class="thumbnail_2"
                                                    referrerpolicy="no-referrer"
                                                    src="../../../assets/advisory/advisory_problem_icon.png"
                                            />
                                            <span class="text-group_8">{{ item.problem.title }}</span>
                                        </div>
                                        <span class="text_38">{{ item.problem.value }}</span>
                                    </div>
                                </div>
                                <div class="solution-section">
                                    <div class="box_16 flex-col">
                                        <div class="icon-wrapper  flex-row justify-between">
                                            <img
                                                    class="thumbnail_2"
                                                    referrerpolicy="no-referrer"
                                                    src="../../../assets/advisory/advisory_solve_icon.png"
                                            />
                                            <span class="text-group_8">{{ item.solve.title }}</span>
                                        </div>
                                        <span class="text_38">{{ item.solve.value }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="list_10">
                    <div class="list-items_1 flex-col" v-for="(item, index) in loopData2" :key="item.id"
                         @click="toggleItem(item.id)">
                        <img
                                v-if="item.slot1 === 1 && !activeItems[item.id]"
                                class="image_10"
                                referrerpolicy="no-referrer"
                                :src="item.specialSlot1.lanhuimage0"
                        />
                        <img
                                v-if="item.slot2 === 2 && !activeItems[item.id]"
                                class="label_5"
                                referrerpolicy="no-referrer"
                                src="../../../assets/advisory/advisory_solve_icon_01.png"
                        />
                        <span class="text_29" v-html="item.lanhutext0" v-show="!activeItems[item.id]"></span>

                        <div class="hover-mask" v-show="activeItems[item.id]">
                            <div class="hover-content">
                                <div class="problem-section">
                                    <div class="box_16 flex-col">
                                        <div class="icon-wrapper flex-row justify-between">
                                            <img
                                                    class="thumbnail_2"
                                                    referrerpolicy="no-referrer"
                                                    src="../../../assets/advisory/advisory_problem_icon.png"
                                            />
                                            <span class="text-group_8">{{ item.problem.title }}</span>
                                        </div>
                                        <span class="text_38">{{ item.problem.value }}</span>
                                    </div>
                                </div>
                                <div class="solution-section">
                                    <div class="box_16 flex-col">
                                        <div class="icon-wrapper  flex-row justify-between">
                                            <img
                                                    class="thumbnail_2"
                                                    referrerpolicy="no-referrer"
                                                    src="../../../assets/advisory/advisory_solve_icon.png"
                                            />
                                            <span class="text-group_8">{{ item.solve.title }}</span>
                                        </div>
                                        <span class="text_38">{{ item.solve.value }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                activeItems: {}, // 用于跟踪每个项目的激活状态
                loopData1: [
                    {
                        id:101,
                        lanhutext0: '数据失真',
                        specialSlot1: {
                            lanhuimage0: require('../../../assets/advisory/advisory_solve_icon01.png'),
                        },
                        problem: {title:'痛点',value:'渠道数据漏报、虚报、篡改导致市场营销计划与返利分配偏差'},
                        solve:{title:'解决方案',value:'通过穿透式核查还原真实业务场景'},
                        slot1: 1
                    },
                    {
                        id:102,
                        lanhutext0: '渠道混乱',
                        specialSlot1: {
                            lanhuimage0:require('../../../assets/advisory/advisory_solve_icon02.png'),
                        },
                        problem: {title:'痛点',value:'经销商层级复杂难管控，架构紊乱，风险频发'},
                        solve:{title:'解决方案',value:'梳理渠道业务关系提升管理效能，降低潜在风险'},
                        slot1: 1
                    },
                ],
                loopData2: [
                    {
                        id:103,
                        lanhutext0: '投资低效',
                        slot2: 2,
                        problem: {title:'痛点',value:'营销费用因中间环节各类隐患与风险导致稀释'},
                        solve:{title:'解决方案',value:'深度洞察精准定位无效投入，优化资源配置策略'},
                    },
                    {
                        id:104,
                        lanhutext0: '管理滞后',
                        specialSlot1: {
                            lanhuimage0: require('../../../assets/advisory/advisory_solve_icon04.png'),
                        },
                        problem: {title:'痛点',value:'传统手段难以及时发现风险'},
                        solve:{title:'解决方案',value:'通过数字化工具实现实时预警，闭环整改风险'},
                        slot1: 1
                    }
                ],
            };
        },
        methods: {
            toggleItem(id) {
                // 切换项目的激活状态
                this.$set(this.activeItems, id, !this.activeItems[id]);
            }
        }
    };
</script>

<style scoped lang="css">
    .page_hx_core {
        background-color: rgba(255, 255, 255, 1);
        position: relative;
        width: 100%;
        overflow: hidden;
    }

    .group_10 {
        width: 100%;
    }
    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .section_9 {
        background-color: rgba(255, 255, 255, 1);
        width: calc(100% - 20px);
        align-items: center;
        padding-left: 10px;
        padding-right: 10px;
    }

    .text_27 {
        width: 100%;
        height: 53px;
        overflow-wrap: break-word;
        color: rgba(18, 20, 28, 1);
        font-size: 24px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: center;
        white-space: nowrap;
        line-height: 53px;
        margin: 48px 0 0 0;
    }

    .text_28 {
        width: 100%;
        height: 37px;
        overflow-wrap: break-word;
        color: rgba(135, 135, 135, 1);
        font-size: 15px;
        text-align: center;
        white-space: nowrap;
        line-height: 37px;
        margin-bottom: 10px;
    }

    .list_10 {
        width: 100%;
        max-width: 1200px;
        margin: 10px 10px 0 10px;
        display: flex;
        justify-content: center;
        gap: 10px;
    }

    .list-items_1 {
        border-radius: 10px;
        position: relative;
        width: 50%;
        max-width: 280px;
        height: 225px;
        border: 1px solid rgba(230, 230, 230, 1);
        align-items: center;
        overflow: hidden;
        cursor: pointer;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .hover-mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(229, 242, 242, 1);
        border-radius: 10px;
        padding: 20px;
        box-sizing: border-box;
    }

    .hover-content {
        color: white;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .problem-section,
    .solution-section {
        display: flex;
        align-items: flex-start;
        gap: 5px;
    }

    .icon-wrapper {
        width: 59px;
        height: 22px;
        margin: 5px 0 0 10px;
    }
    .thumbnail_2 {
        width: 18px;
        height: 18px;
        margin-top: 2px;
        margin-right: 8px;
    }
    .text-group_8 {
        width: 32px;
        height: 22px;
        overflow-wrap: break-word;
        color: rgba(0, 106, 112, 1);
        font-size: 16px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 22px;
    }
    .text_38 {
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 18px;
        text-align: left;
        line-height: 25px;
        margin: 2px 0 0 35px;
    }

    .image_10 {
        position: absolute;
        top: 65px;
        width: 50px;
        height: 50px;
    }

    .label_5 {
        position: absolute;
        top: 68px;
        width: 31px;
        height: 44px;
    }

    .text_29 {
        width: 180px;
        height: 30px;
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 22px;
        text-align: center;
        white-space: nowrap;
        line-height: 30px;
        margin: 139px 0 0 0;
    }

    /* 超小屏幕样式 */
    @media (max-width: 480px) {
        .hover-mask {
            padding: 6px;
        }
        .text_38 {
            font-size: 10px;
            text-align: left;
            line-height: 15px;
            margin: 2px 0 0 35px;
        }
        .solution-section {
            margin-top: -5px;
        }
        .list-items_1 {
            height: 140px;
        }
        .image_10 {
            top: 35px;
            width: 40px;
            height: 40px;
        }
        .label_5 {
            top: 35px;
            width: 30px;
            height: 40px;
        }
        .text_29 {
            font-size: 20px;
            margin: 90px 0 0 0;
        }
        .text-group_8 {
            font-size: 15px;
        }
    }
    @media (max-width: 390px) {
        .hover-mask {
            padding: 4px;
        }
        .text_38 {
            font-size: 10px;
            text-align: left;
            line-height: 15px;
            margin: 2px 0 0 35px;
        }
        .solution-section {
            margin-top: -5px;
        }
        .list-items_1 {
            height: 140px;
        }
        .image_10 {
            top: 35px;
            width: 40px;
            height: 40px;
        }
        .label_5 {
            top: 35px;
            width: 30px;
            height: 40px;
        }
        .text_29 {
            font-size: 20px;
            margin: 90px 0 0 0;
        }
        .text-group_8 {
            font-size: 14px;
        }
    }
</style>
